import { checkDateIsOld } from '../dateTimeService';
import { getSettings } from '../settingsService';
import {
  GroupNameEnum,
  IUserAuth,
  UserGroups,
} from '../../store/authentication/types';

class UserAuthentication implements IUserAuth {
  public readonly idToken: string;

  constructor(idToken: string) {
    this.idToken = idToken;
  }

  public getIdToken(): string {
    return this.idToken;
  }

  public getUserName(): string {
    return this.getPayloadFromToken()['cognito:username'];
  }

  public getUserEmail(): string {
    return (this.getPayloadFromToken() as any).email;
  }

  public getMappedUserGroups(): { [id in string]: number } {
    const settings = getSettings();
    return {
      [settings[GroupNameEnum.WIND_BT_PORTAL]]: UserGroups.RAIL,
      [settings[GroupNameEnum.INDUSTRY_BT_PORTAL]]: UserGroups.RAIL,
      [settings.skfGroupName]: UserGroups.SKF,
      [settings[GroupNameEnum.WIND]]: UserGroups.WIND,
      [settings[GroupNameEnum.RAIL]]: UserGroups.RAIL,
      [settings[GroupNameEnum.PORTAL]]: UserGroups.PORTAL,
      [settings[GroupNameEnum.INDUSTRY]]: UserGroups.INDUSTRY,
      [settings[GroupNameEnum.CUSTOMER_PORTAL]]: UserGroups.CUSTOMER_ACCESS,
      [settings[GroupNameEnum.CV4REMAN_PORTAL]]: UserGroups.CV4REMAN_ACCESS,
      [settings[GroupNameEnum.REMANXP_PORTAL]]: UserGroups.REMANXP_ACCESS,
    };
  }

  public getUserGroups(): string[] {
    return this.getPayloadFromToken()['cognito:groups'];
  }

  public isUserInGroup(userGroup: string): boolean {
    const userGroups = this.getUserGroups();
    if (!userGroups || userGroups.length === 0) return false;

    return userGroups.findIndex((ug) => ug === userGroup) !== -1;
  }

  public hasTokenExpired(): boolean {
    const expiration = this.getTokenExpiration();
    return checkDateIsOld(expiration);
  }

  public getTokenExpiration(): number {
    return (this.getPayloadFromToken() as any).exp;
  }

  private getPayloadFromToken(): object {
    if (!this.idToken)
      throw new Error('Unable to deserialize idToken, no idToken');
    return JSON.parse(atob(this.idToken.split('.')[1]));
  }
}

export { UserAuthentication as UserAuth };
